export * from './recent-contacts.component';
